<template>
  <div class="hello">
    <!--    刷新-->
      <!--      内容-->
      <div v-if="bottomTab == 0" class="content">
        <!--        上半部内容-->
        <div class="header" style="position:fixed;top: 0">
          <img src="../assets/topback.png" style="width: 50%;height: 75%;float: right;margin-top: 30px;" alt="" />
          <div class="headtop">
            <h2><span>生</span>活缴费</h2>
            <p>便携生活，一点就好</p>
          </div>
        </div>
        <!--        中部-->
        <div class="center" style="position: relative;top: 20vh;">
          <div class="center_all">
            <van-tabs v-model:active="active" style="" line-width="70">
              <van-tab title="我的缴费">
                <div class="option_region" v-for="item in information" @click="manyJump(item)">
                  <img src="../assets/water.png" v-if="item.devType==1" style="width:40px;height:40px;float: left;margin-top: 20px;margin-left: 5px;" alt=""/>
                  <img src="../assets/dian.png" v-else style="width:40px;height:40px;float: left;margin-top: 20px;margin-left: 5px;" alt=""/>
                  <div style="margin-top: 20px;margin-left: 50px;">
                    <p v-if="item.devType==1">水费</p>
                    <p v-else>电费</p>
                    <p style="margin-top: 7px;">{{item.houseHoldNumber}}</p>
                  </div>
              </div>
                <van-popup v-model="show" round position="bottom" :style="{ height: '30%' }">
                  <p style="margin-top: 20px;margin-left: 10px;">新增缴费</p>
                  <div class="option_region insregion" @click="waterJump">
                    <img src="../assets/water.png" style="width:40px;height:40px" alt="" />
                    <p>水费</p>
                  </div>
                  <div class="option_region insregion" @click="electricJump">
                    <img src="../assets/dian.png" style="width:40px;height:40px" alt="" />
                    <p>电费</p>
                  </div>
                </van-popup>
                <div class="option_region add" @click="inserts">
                  <img src="../assets/add.png" style="width:50px;height:50px" alt="" />
                  <p>新增缴费</p>
                </div>
                <div class="clear"></div>
                <div class="moneyAll" @click="moneyJump">
                  <span style="color: #0074D9">缴费管理</span>
                </div>
              </van-tab>
              <van-tab title="缴费记录">
                <button @click.stop="allment" style="margin-left:15%;border:none;background-color:#1989fa;color:#fff;height:30px;width:50px;margin-top: 10px">全部</button>
                <div id="main" style="width:350px;height:300px;margin: 0 auto;"></div>
              </van-tab>
            </van-tabs>
          </div>
        </div>
      </div>
      <div v-else-if="bottomTab == 1" class="person">
        <div class="top"></div>
        <div class="center" style="background-color: #fff;border-radius: 15px;height: 30vh;width:80%;margin:0 auto">
          <div style="margin-top:-10vh;height: 20vh;border:1px solid #f2f2f4;border-radius: 15px;  box-shadow: #eef0fc 0px 5px 10px 0px;">
            <div style="width: 50px;height: 50px;border-radius: 50px;border: 1px solid #fff;margin: 0 auto">
              <img :src="personCon.headUrl" style="width: 50px;height: 50px;border-radius: 50px;border:2px solid #f0f0f0;margin-top:-30px" alt="">
            </div>
            <div style="text-align: center;font-weight: bold">
              <span style="font-family: '黑体'">{{personCon.nickname}}</span>
            </div>
            <div style="padding:20px">
              <ul style="text-align: center">
                <li style="color: #518ff4;font-weight: bold">￥{{personCon.balance}}</li>
                <li style="color: #939393;font-size: 13px;font-family: '黑体';margin-top: 2px">住户余额</li>
              </ul>
            </div>
          </div>
          <div class="buttonIm">
            <ul>
              <li style="float: left;margin-left: 10%" @click="bindRoom">
                <img src="../../images/link.png" alt="">
                <div>
                  <span style="font-family: '黑体';font-size: 13px" v-if="personCon.houseId == 0 || personCon.houseId == '' || personCon.houseId == undefined">绑定住户</span>
                  <span style="font-family: '黑体';font-size: 13px" v-else>已绑定住户</span>
                </div>
              </li>
              <li style="float: left;margin-left: 10%" v-if="personCon.houseId == 0 || personCon.houseId == '' || personCon.houseId == undefined">
              </li>
              <li style="float: left;margin-left: 10%" @click="bindCost" v-else>
                <img src="../../images/link.png" alt="">
                <div>
                  <span style="font-family: '黑体';font-size: 13px">额外费用</span>
                </div>
              </li>
              <li style="float: right;margin-right: 10%" @click="bindBalance">
                <img src="../../images/up.png" alt="">
                <div>
                  <span style="font-family: '黑体';font-size: 13px">充值余额</span>
                </div>
              </li>
            </ul>
          </div>
          <div style="padding-top:15vh">
            <van-cell icon="records" style="margin-top: 20px" title="充值记录" @click="recordGo" is-link />
            <van-cell icon="warning-o" style="margin-top: 20px" @click="faultMe" title="故障上报" is-link />
            <van-cell icon="comment-o" style="margin-top: 20px" title="意见反馈" @click="feedGo" is-link />
            <van-cell icon="friends-o" style="margin-top: 20px" title="关于我们" @click="aboutGo" is-link />
          </div>
        </div>
      </div>
    <div style="height: 6vh;">
      <van-tabbar v-model="bottomTab" placeholder fixed>
        <van-tabbar-item icon="home-o">首页</van-tabbar-item>
        <van-tabbar-item icon="friends-o">我</van-tabbar-item>
      </van-tabbar>
    </div>

  </div>

</template>

<script>

import { Toast } from 'vant';
import * as echarts from 'echarts'
import jump from "../common/jump";
import {bannerList, chart, payment, person, realTime, miniwxLogin} from "../common/api/index/index.js"
export default {
  data(){
    return{
      show:false,//弹出页面判断
      token:'',//token值
      images: [],//banner图片
      active:'',//选项卡
      loading:false,//刷新图标
      information:[],//缴费信息
      realInfo:[],//资讯信息
      alldata:[],//轮播图
      alldatatitle:[],//轮播图
      bottomTab:0, /*tab 切换页面*/
      personCon:[]
    }
  },
  methods:{
    bindCost(){
      this.$router.push({path:'/cost'})
    },
    bindBalance(){
      if(this.personCon.houseId == 0 || this.personCon.houseId == '' || this.personCon.houseId == undefined){
        Toast("请绑定住户后再进行充值哦")
      }
      else{
        this.$router.push({path:'/rechargeBalance',query:this.personCon})
      }
    },
    bindRoom(){
      this.$router.push({path:'/room',query:this.personCon})
    },
    faultMe(){
      this.$router.push({path:'/default',query:this.information})
    },
    aboutGo(){
      this.$router.push({path:'/about'})
    },
    feedGo(){
      this.$router.push({path:'/feed'})
    },
    recordGo(){
      this.$router.push({path:'/record'})
    },

    //判断水电费跳转预后付费页面
    manyJump:function(row){
      if(row.devType === 1){
        if(row.payType == 1){
          this.$router.push({
            path: "/waterelall",
            query:{
              houseHoldNumber:row.houseHoldNumber,
              phone:row.phone,
              mchNumber:row.mchNumber,
              address:row.actName,
              payType:row.payType,
              devId:row.devId,
              devType: row.devType,
              productId:row.productId,
              id:row.id,
              tenantId:row.tenantId,
              mchName:row.mchName,
            }
          })
        }
        else if(row.payType == 0){
          this.$router.push({
            path: "/watmentw",
            query:{
              phone:row.houseHoldNumber
            }
          })
        }
      }
      else if(row.devType == '0'){
        if(row.payType == 1){
          this.$router.push({
            path: "/elall",
            query:{
              houseHoldNumber:row.houseHoldNumber,
              phone:row.phone,
              tenantId:row.tenantId,
              mchName:row.mchName,
              mchNumber:row.mchNumber,
              address:row.actName,
              payType:row.payType,
              devId:row.devId,
              devType:row.devType,
              productId:row.productId,
              id:row.id
            }

          })
        }
        else if(row.payType == 0){
          jump.$emit('goNext')
          this.$router.push({
            path: "/mentw",
            query:{
              phone:row.houseHoldNumber,
            }
          })
        }
      }
    },
    //缴费管理跳转页面
    moneyJump:function(){
      this.$destroy()
      this.$router.push({path: "/management"})
    },
    //资讯的外部链接跳转
    jumpSide:function(url){
      window.location.href = url
    },
    //首页缴费记录全部按钮的跳转
    allment:function(){
      this.$router.push({path: "/allment"})
    },
    //新增水费页面跳转
    waterJump:function(){
      this.show = false
      this.$destroy()
      this.$router.push({path: "/charge"})
    },
    //新增电费页面跳转
    electricJump:function(){
      this.show = false
      this.$destroy()
      this.$router.push({path: "/pay"})
    },
    //点击新增缴费跳出的弹框
    inserts:function(){
      this.show = true
    },
    //时间转换
    formatDate (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      return MM;
    },
    //首页获取六个月缴费数据
    echartsSix:function(){
      this.alldatatitle = []
      this.alldata = []
      chart().then(response =>{
        for(let i =0;i<response.data.items.length;i++){
          this.alldatatitle.push(this.formatDate(parseInt(response.data.items[i].timestamp)) + "月")
          this.alldata.push(response.data.items[i].totalMoney)
        }
        setTimeout( () => {
          this.echarts()
        },3000)

      })
    },
    //显示六个月数据折线图
    echarts:function(){
      var myChart = echarts.init(document.getElementById('main'));
      var option = {
        xAxis: {
          type: 'category',
          data: this.alldatatitle
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.alldata,
            type: 'line'
          }
        ]
      };
      myChart.setOption(option);
    },
    //资讯的获取
    getArticle:function(){
      this.realInfo = []
      realTime().then(response => {
        for(let i=0;i<response.data.items.length;i++){
          this.realInfo.push({title:response.data.items[i].title,content:response.data.items[i].content,messageUrl:response.data.items[i].messageUrl})
        }
      })
    },
    //获取缴费信息
    getCenterContent:function(){
      payment().then(response => {
        this.information = response.data.items
      })
    },
    //获取banner图片
    getBanner:function(){
      this.images = []
      bannerList().then(response => {
        for(let i =0;i<response.data.items.length;i++){
          this.images.push(response.data.items[i].imgUrl)
        }
      } )
    },
    //刷新内容
    allRefresh(){
      this.getCenterContent()
      this.getBanner()
      this.echartsSix()
      this.getArticle()
      this.personContent()
    },
    personContent(){
      person().then( res => {
        this.personCon = res.data
      })
    }
  },
  mounted() {
    let hrefs = window.location.href
    let token = hrefs.split("=")
    let appOrToken = token[0].slice(-5)
    //判断公众号（带appid是小程序未授权，带token是appid授权，同小程序）or小程序
    if(appOrToken == "appid"){
      // window.location.href = 'http://h5.hzjf.top/wx/portal/'+token[1]
      console.log('参数appid:', this.$route.query.appid, '参数code:', this.$route.query.code)
      let appid = this.$route.query.appid
      let code = this.$route.query.code
      let that = this
      miniwxLogin(appid, code).then(res=>{
        console.log('登录参数:', res)
        that.token = this.$cookies.set('token',res.data.token, 21600)
        that.allRefresh()
      })
    }
    else{
      if(token[1] == undefined){}
      else{
        this.token = this.$cookies.set('token',token[1], 21600)
      }
      this.allRefresh()
    }
  },
}

</script>

<style scoped>
*{
  margin: 0;
  padding:0;
}

.hello{
  height: auto !important;
}
.content{
  background-color: #F6F6F6;
  width: 100%;
  height: 90vh;
  padding-bottom: 10px;
}
.foot_body::-webkit-scrollbar{
  height: 0;
  width: 0;
}

.header{
  width: 100%;
  height: 12vh;
  background-color: #295ad0;
}
#main div{
  width:100%;
}
#main div canvas{
  width: 100%;
}
.headtop{
  letter-spacing:2px;
  color: rgb(255, 255, 255);

  position: relative;

  top:50px;
  margin-left:20px
}
.headtop p{
  margin-top: 10px;
  font-size: 10px;
}
.header h2 span{
  border-bottom: 3px solid #fff;
}
.header{
  height:25vh;
  background-color:#295ad0;

}
.center{
  margin-top:-15px;
  height: 71vh;
}
.center_all{
  width:90%;
  background-color: #fff;
  box-shadow: #dee1e5 0px 0px 15px -5px;
  border-radius: 10px;
  margin: 0 auto;
  height: 95%;
}
.add{
  text-align: center;
}
.add img{
  margin-top: 10px;
}
.option_region{
  width:46%;
  height:90px;
  float: left;
  background-color: #fff;
  margin-left:7px;
  margin-top:30px;
  box-shadow: #dee1e5 0px 0px 15px -5px;
  border: 1px solid #DEE1E5;
  border-radius: 10px;
}
.option_region span{
  color: #8e8e8e;
  font-size: 12px;
}
.option_region p{
  font-size: 12px;
}
.insregion{
  text-align: center;
  padding-top: 10px;
}
.insregion p{
  margin-top: 10px;
}
.clear{
  clear: both;
}
.foot{
  width:90%;
  margin:0 auto;
  background-color: #fff;
  box-shadow: #dee1e5 0px 0px 15px -5px;
  border-radius: 10px;
  margin-top: 50px;
}
.foot_body{
  margin: 0 auto;
  width:100%;
}
.foot_body ul li{
  list-style: none;
}
.foot .foot_body_tex{
  padding-top:22px;
  padding-left: 118px;
}
.foot .foot_body_tex p{
  margin-top: 10px;
  letter-spacing: 1px;
  font-size:12px;
  color:#8e8e8e;
}

.foot .foot_body_img{
  float: left;
  margin:10px auto;
}

.foot .foot_body_img img{
  width:80px;
  height:70px;
  float: left;
  margin-top: 10px;
  margin-left: 20px;
}
/deep/.van-tabs__wrap{
  border-radius: 12px;
}
/deep/.van-tab--active{
  font-size: 15px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
}
/deep/.van-tabs__line{
  background-color: #687fe5;
}
.moneyAll{
  text-align:right;
  display:block;
  margin-top:20px;
  padding-bottom:20px;
  margin-right:20px
}
.person{
  height: 94vh;
}
.person .top{
  height: 20vh;
  background-color: #295ad0;
  /*background:linear-gradient( to right,#758eca,#295ad0)*/
}
.buttonIm{
  margin:50px auto
}
.buttonIm ul{
  text-align: center;
}
.van-cell__title span{
  font-size: 14px;
  font-family: '黑体';
}
.van-cell::after{
  border: none;
}
</style>
